<template>
  <div>
    <div
        v-for="note in notes" :key="note.id"
        class="mb-3">
      <div class="border py-2 px-3 position-relative">
        <div>{{note.text}}.</div>
        <div v-if="note.createdAt">
          <small class="text-muted">Создано {{formatDate(note.createdAt)}}</small>
        </div>

        <div
            class="position-absolute"
            style="right:0;top:0;cursor: pointer;"
            @click="selectItem(note.id)">
          <i class="fas fa-edit text-muted"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientNote',

  props: ['notes'],

  data() {
    return {};
  },

  methods: {
    async selectItem(id) {
      this.$emit('select', id);
    },

    formatDate(date) {
      return typeof date === 'undefined' ? '' : formatDate(new Date(date), 'd.m.y');
    },
  },
};
</script>
